import { isAndroid } from 'src/utils/platform';
import { FunctionComponent } from 'react';
import { twMerge } from 'src/utils/twMerge';
import './SafeArea.css';

type Props = { className?: string };

const SafeAreaBottom: FunctionComponent<Props> = ({ className }) => {
  return (
    <div
      className={twMerge(
        `safe-area safe-area-position-bottom`,
        isAndroid()
          ? 'safe-area-android'
          : 'safe-area-ios',
        className,
      )}
    />
  );
};

export default SafeAreaBottom;
